var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Panama(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M24,4C12.954,4,4,12.954,4,24h20V4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M24,44c11.046,0,20-8.954,20-20H24V44z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#01579b",
    d: "M4,24c0,11.046,8.954,20,20,20V24H4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#d32f2f",
    d: "M24,4v20h20C44,12.954,35.046,4,24,4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#01579b",
    d: "M19,14.031h-3.055L15,11.129l-0.945,2.902H11l2.473,1.797l-0.945,2.906L15,16.941l2.473,1.793 l-0.945-2.906L19,14.031z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#d32f2f",
    d: "M34.527,32.828L37,31.031h-3.055L33,28.125l-0.945,2.906H29l2.473,1.797l-0.945,2.906L33,33.938 l2.473,1.797L34.527,32.828z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Panama);
export default __webpack_public_path__ + "static/media/icons8-panama.7f6a514d4eb0272dc8f8c951659c4445.svg";
export { ForwardRef as ReactComponent };